import { link } from '../../services/routing'
import { Button } from '../button'
import { Centered } from '../centered'
import { Icon } from '../icon'
import { Heading, Paragraph } from '../typography'

interface Props {
  errorText?: string
  onRetry?: () => void
}

export function SearchError({ errorText = 'There’s been an error fetching your results.', onRetry }: Props) {
  return (
    <Centered className="h-52 flex-1 flex-col gap-2 p-1">
      <Icon width={24} name="warning" className="text-gray-600" />
      <Heading level={5}>Error fetching the results</Heading>
      <Paragraph size="small" className="w-100 text-center text-gray-600 dark:text-gray-400">
        {errorText}
        <br />
        If you’re encountering this error repeatedly, please{' '}
        <a href={link.toContact()} className="text-link">
          contact support
        </a>
        .
      </Paragraph>
      {onRetry && (
        <Button theme="blueHover" onClick={onRetry}>
          Retry
        </Button>
      )}
    </Centered>
  )
}
